import validate from "/data/www/musikum_portal/prod/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@20.6.2_db0@0.2.3_eslint@8.49.0_ioredis@5.4.2_ma_5b5lnjm2odf2fgj57fbbrw6u6a/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/data/www/musikum_portal/prod/.app/middleware/auth.global.ts";
import common_45global from "/data/www/musikum_portal/prod/.app/middleware/common.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global,
  common_45global
]
export const namedMiddleware = {}